// extracted by mini-css-extract-plugin
export var container = "_f0-0";
export var icon = "_f0-1";
export var text = "_f0-2";